module.exports = __webpack_public_path__ + "static/miami2-7893b90348f2bc002d1298914aa43cec.jpeg";